<unity-breadcrumbs>
  <li unity-breadcrumbs-item *ngFor="let item of items">
    <a [routerLink]="[item.link]" class="em-c-breadcrumbs__link">{{
      item.text
    }}</a>
  </li>
</unity-breadcrumbs>
